export let life = {
  mounted() {
    this.methods('initInterval');
    $(window).on('sessionFail',()=>{
      clearInterval(this.refreshinterval);
      clearInterval(this.tradeMissInterval);
    })
  },
  beforeDestroy() {
    $(window).off('sessionFail');
    // 离开组件后清楚轮询
    clearInterval(this.refreshinterval);
    clearInterval(this.tradeMissInterval);
    // 取消所有语音队列
    window.speechSynthesis.cancel();
    // 离开页面时关闭所有通知
    for (const n of this.notifications) {
      if (n) {
        try {
          n.close();
        } catch (e) {
          console.log('关闭通知错误:', e);
        }
      }
    }
    this.notifications = [];
  }
};
export let event = {
  toPage(type) {
    this.$router.push({ name: type });
  }
};
export let watch = {};
